// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"xLEaimc","header":"Zb-NiHG","body":"_4dx9Nn7","close":"_3rZlkmo","link":"yFABGnh","container":"_2nFo01D","outerWrapper":"_1__Ug8F","innerWrapper":"_2jIx_En","slidedown":"_2Ydfmv-","wrapper__open":"_1NIO-n7","wrapper__hidden":"_3YiroC7"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Dropdown/index.css
// module id = ./template/components/Dropdown/index.css
// module chunks = client.sitechrome